import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { MetaDirective, MetaFieldComponent, MetaObject } from '@softline/dynamic';
import { TimeReport } from '../../models/time-report.model';

@Component({
  selector: 'soft-time-report-item',
  imports: [MetaDirective, MetaFieldComponent],
  templateUrl: './time-report-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './time-report-item.component.css' })
export class TimeReportItemComponent {
  meta = input.required<MetaObject<TimeReport>>();
  value = input.required<TimeReport>();
}
